/**
 * Generated by orval 🍺
 * Do not edit manually.
 * General Wisdom API Contract
 * OpenAPI spec version: 0.1.0
 */
import { orvalFetch } from '../orvalMutator';
import { orvalNoContent } from '../orvalMutator';
import { orvalResponse } from '../orvalMutator';

/**
 * Request body for POST `/user/collections/add_offer_by_url`.
 */
export interface AddOfferByUrlRequest {
  /** Marketplace product URL to fetch and add to the default collection. */
  url: string;
}

/**
 * Distinguishes whether one evidence row asserted or retracted an edge.
 */
export type JudgmentKindDto = (typeof JudgmentKindDto)[keyof typeof JudgmentKindDto];

export const JudgmentKindDto = {
  assert: 'assert',
  retract: 'retract',
} as const;

/**
 * API-facing triple DTO for reducer-native admin schema views.
 * This mirrors the public fields selected from `base::kr::Triple<ConceptRef>`.
 */
export interface TripleDto {
  /** The literal object identifier. */
  obj: string;
  /** The relation identifier. */
  rel: string;
  /** The literal subject identifier. */
  sub: string;
}

/**
 * Carries one literal judgment requested by the admin schema editor.
 */
export interface AdminSchemaJudgmentInputDto {
  /**
   * Carries the optional administrator justification.
   * @nullable
   */
  justification?: string | null;
  /** Identifies whether the literal triple is asserted or retracted. */
  kind: JudgmentKindDto;
  /** Identifies the literal triple to assert or retract. */
  triple: TripleDto;
}

/**
 * Requests one atomic admin schema judgment commit.
 */
export interface AdminSchemaCommitJudgmentsRequest {
  /** Lists every judgment that must persist atomically. */
  judgments: AdminSchemaJudgmentInputDto[];
}

/**
 * Reports the result of one atomic admin schema judgment commit.
 */
export interface AdminSchemaCommitJudgmentsResponse {
  /** Reports the shared server timestamp assigned to the committed judgments. */
  committed_at: string;
  /**
   * Reports how many judgments were persisted.
   * @minimum 0
   */
  committed_count: number;
}

/**
 * Reports whether a composed canonical bucket has any active member source.
 */
export type ComposedResolutionDto =
  | {
      status: 'active';
    }
  | {
      status: 'inactive';
    };

/**
 * API-facing provenance for one reducer evidence row when true provenance exists.
 */
export interface TripleProvenanceDto {
  /**
   * Records when the raw recon judgment was created, when persisted.
   * @nullable
   */
  created_at?: string | null;
  /** Identifies who created the raw recon judgment. */
  creator: string;
  /** Indicates whether the creator string matches a configured LLM model identifier. */
  creator_is_llm: boolean;
  /**
   * Carries the persisted raw-judgment justification, when present.
   * @nullable
   */
  justification?: string | null;
}

/**
 * Identifies which physical source produced one reducer evidence row.
 */
export type SourceTableDto = (typeof SourceTableDto)[keyof typeof SourceTableDto];

export const SourceTableDto = {
  recon: 'recon',
  schema: 'schema',
} as const;

/**
 * Preserves one reducer evidence row for admin schema diagnostics.
 */
export interface EvidenceRowDto {
  /** Identifies whether this evidence row asserted or retracted the triple. */
  kind: JudgmentKindDto;
  provenance?: null | TripleProvenanceDto;
  /** Identifies which source path produced this evidence row. */
  source_table: SourceTableDto;
}

/**
 * Carries one reason a reduced triple is inactive.
 */
export type ExclusionDto =
  | {
      /**
       * Points at `ReducedTripleDto.evidence[by_index]`.
       * @minimum 0
       */
      by_index: number;
      type: 'retracted';
    }
  | {
      /** Identifies the concept disqualified by the effective quality judgment. */
      disqualifying_concept: string;
      /** Identifies the effective quality value that caused the exclusion. */
      quality: string;
      type: 'filtered_by_concept_quality';
    };

/**
 * Reports whether a reduced triple is active or inactive.
 */
export type ResolutionDto =
  | {
      status: 'active';
      /**
       * Points at `ReducedTripleDto.evidence[winner_index]`.
       * @minimum 0
       */
      winner_index: number;
    }
  | {
      /** Lists the reasons no evidence row survived as active. */
      exclusions: ExclusionDto[];
      status: 'inactive';
    };

/**
 * Mirrors `ReducedTriple` for literal sections in the admin schema view.
 */
export interface ReducedTripleDto {
  /** Preserves all reducer evidence rows considered for this bucket. */
  evidence: EvidenceRowDto[];
  /** Reports the reducer outcome for this bucket. */
  resolution: ResolutionDto;
  /** Carries the literal triple key. */
  triple: TripleDto;
}

/**
 * Preserves one member bucket contributing to a composed canonical row.
 */
export interface ComposedSourceDto {
  /** Identifies which equivalence-class member contributed this literal bucket. */
  member: string;
  /** Preserves the full reduced literal bucket for this member. */
  reduced: ReducedTripleDto;
}

/**
 * Mirrors one canonical/composed reduced bucket for the admin schema view.
 */
export interface ComposedReducedTripleDto {
  /** Reports canonical activity using union-of-active semantics. */
  resolution: ComposedResolutionDto;
  /** Preserves lineage back to member literal reduced buckets. */
  sources: ComposedSourceDto[];
  /** Carries the canonicalized triple key. */
  triple: TripleDto;
}

/**
 * Carries one canonical/composed section anchored to the resolved cref.
 */
export interface ComposedSectionDto {
  /** Lists active canonical buckets for the anchor. */
  active: ComposedReducedTripleDto[];
  /** Identifies the cref anchoring this canonical section. */
  anchor: string;
  /** Lists inactive canonical buckets for the anchor. */
  inactive: ComposedReducedTripleDto[];
}

/**
 * Carries one literal reducer-native section anchored to a member cref.
 */
export interface LiteralSectionDto {
  /** Lists active reduced literal buckets for the anchor. */
  active: ReducedTripleDto[];
  /** Identifies the cref anchoring this literal section. */
  anchor: string;
  /** Lists inactive reduced literal buckets for the anchor. */
  inactive: ReducedTripleDto[];
}

/**
 * API response for the reducer-native admin schema view endpoint.
 */
export interface AdminSchemaViewResponse {
  /** Carries canonicalized composed triples aggregated from member literal buckets. */
  composed: ComposedSectionDto;
  /** Carries literal reduced sections for every member in the resolved equivalence class. */
  equivalence_class: LiteralSectionDto[];
  /** Carries reducer-native literal triples for the requested cref. */
  focus: LiteralSectionDto;
  /** Echoes the cref requested by the caller before any recon resolution. */
  focus_cref: string;
  /** Carries the canonical cref after applying recon resolution. */
  resolved_cref: string;
}

/**
 * Safe reasons for HTTP requests rejected outside application error handling.
 */
export type RequestRejection = (typeof RequestRejection)[keyof typeof RequestRejection];

export const RequestRejection = {
  malformed_request: 'malformed_request',
  route_not_found: 'route_not_found',
  method_not_allowed: 'method_not_allowed',
  payload_too_large: 'payload_too_large',
  uri_too_long: 'uri_too_long',
  unsupported_media_type: 'unsupported_media_type',
  unprocessable_entity: 'unprocessable_entity',
  too_many_requests: 'too_many_requests',
  other: 'other',
} as const;

/**
 * Safe validation reasons generated into the frontend HTTP contract.
 * These preserve actionable distinctions without exposing parser or storage internals.
 */
export type RequestError = (typeof RequestError)[keyof typeof RequestError];

export const RequestError = {
  only_authentication_method: 'only_authentication_method',
  oauth_identity_not_found: 'oauth_identity_not_found',
  invalid_url: 'invalid_url',
  unsupported_marketplace: 'unsupported_marketplace',
  product_id_missing: 'product_id_missing',
  product_variant_required: 'product_variant_required',
  search_query_too_long: 'search_query_too_long',
  invalid_invite_credit_quantity: 'invalid_invite_credit_quantity',
  invalid_concept_reference: 'invalid_concept_reference',
  justification_too_long: 'justification_too_long',
  invalid_judgment_subject: 'invalid_judgment_subject',
  invalid_judgment_relation: 'invalid_judgment_relation',
  invalid_judgment_object: 'invalid_judgment_object',
  reflexive_assertion: 'reflexive_assertion',
  unsupported_relation: 'unsupported_relation',
  invalid_quality: 'invalid_quality',
  empty_judgments: 'empty_judgments',
  too_many_judgments: 'too_many_judgments',
  duplicate_judgment: 'duplicate_judgment',
  invalid_judgment_request: 'invalid_judgment_request',
} as const;

/**
 * Error identifiers returned to API clients.
 */
export type ClientError =
  | {
      type: 'no_auth';
    }
  | {
      type: 'service_error';
    }
  | {
      type: 'reg_fail';
    }
  | {
      reason: RequestRejection;
      type: 'request_rejected';
    }
  | {
      reason: RequestError;
      type: 'invalid_request_data';
    }
  | {
      type: 'oauth_code_already_used';
    }
  | {
      type: 'forbidden';
    }
  | {
      type: 'user_not_found';
    }
  | {
      type: 'product_not_found';
    }
  | {
      type: 'invalid_product_reference';
    }
  | {
      type: 'registration_login_failed';
    }
  | {
      type: 'document_not_found';
    };

/**
 * Machine-readable error details returned by every HTTP error response.
 */
export type ApiErrorBody = ClientError & {
  req_uuid: string;
};

/**
 * Shared HTTP error response envelope.
 */
export interface ApiErrorEnvelope {
  error: ApiErrorBody;
}

/**
 * Reports whether the current request carries an authenticated session.
 */
export interface AuthCheckResponse {
  valid: boolean;
}

export type ClosedEmptyObject = Record<string, never>;

/**
 * Carries editable config for generated-initials avatars.
 */
export interface GeneratedInitialsAvatarConfigDto {
  /** Stores the normalized background color used for the generated avatar. */
  background_color: string;
  /** Stores the initials rendered into the generated avatar. */
  initials: string;
}

/**
 * Describes which avatar source to preview together with its config payload.
 */
export type AvatarPreviewRequest =
  | {
      /** Requests a preview of the built-in placeholder avatar. */
      config: ClosedEmptyObject;
      source: 'default_placeholder';
    }
  | {
      /** Requests a preview of a generated-initials avatar. */
      config: GeneratedInitialsAvatarConfigDto;
      source: 'generated_initials';
    };

/**
 * Wraps a source-specific avatar config together with its availability flag.
 */
export interface AvatarSettingsSourceDtoDefaultPlaceholderAvatarConfigDto {
  /** Indicates whether the avatar source is currently available to the user. */
  available: boolean;
  config: ClosedEmptyObject;
}

/**
 * Carries editable config for generated-initials avatars.
 */
export type AvatarSettingsSourceDtoGeneratedInitialsAvatarConfigDtoConfig = {
  /** Stores the normalized background color used for the generated avatar. */
  background_color: string;
  /** Stores the initials rendered into the generated avatar. */
  initials: string;
};

/**
 * Wraps a source-specific avatar config together with its availability flag.
 */
export interface AvatarSettingsSourceDtoGeneratedInitialsAvatarConfigDto {
  /** Indicates whether the avatar source is currently available to the user. */
  available: boolean;
  /** Carries editable config for generated-initials avatars. */
  config: AvatarSettingsSourceDtoGeneratedInitialsAvatarConfigDtoConfig;
}

/**
 * Collects the editable config for each avatar source supported by the settings UI.
 */
export interface AvatarSettingsOptionsDto {
  /** Exposes availability and config for the placeholder avatar source. */
  default_placeholder: AvatarSettingsSourceDtoDefaultPlaceholderAvatarConfigDto;
  /** Exposes availability and config for the generated-initials avatar source. */
  generated_initials: AvatarSettingsSourceDtoGeneratedInitialsAvatarConfigDto;
}

/**
 * Holds optional per-source config updates for avatar settings patch requests.
 */
export interface AvatarSettingsPatchConfigsDto {
  default_placeholder?: null | ClosedEmptyObject;
  generated_initials?: null | GeneratedInitialsAvatarConfigDto;
}

/**
 * Enumerates avatar source identifiers shared with the frontend avatar settings UI.
 */
export type AvatarSourceDto = (typeof AvatarSourceDto)[keyof typeof AvatarSourceDto];

export const AvatarSourceDto = {
  default_placeholder: 'default_placeholder',
  generated_initials: 'generated_initials',
} as const;

/**
 * Provides avatar-setting suggestions that the frontend can prefill for the user.
 */
export interface AvatarSettingsSuggestionsDto {
  /**
   * Suggests initials derived from the user's profile information when available.
   * @nullable
   */
  generated_initials?: string | null;
}

/**
 * Returns the selected avatar source, editable configs, and UI suggestions.
 */
export interface AvatarSettingsResponse {
  /** Lists preset background colors that the generated-initials UI should offer. */
  generated_initials_preset_colors: string[];
  /** Lists the available avatar sources and their current config. */
  options: AvatarSettingsOptionsDto;
  /** Identifies which avatar source is currently selected. */
  selected: AvatarSourceDto;
  /** Provides suggested values that the frontend may surface to the user. */
  suggestions: AvatarSettingsSuggestionsDto;
}

/**
 * Identifies which avatar config field failed validation.
 */
export type AvatarValidationErrorCode =
  (typeof AvatarValidationErrorCode)[keyof typeof AvatarValidationErrorCode];

export const AvatarValidationErrorCode = {
  required: 'required',
  too_long: 'too_long',
  invalid_characters: 'invalid_characters',
  invalid_hex_color: 'invalid_hex_color',
} as const;

/**
 * Groups per-field validation errors for avatar settings requests.
 */
export interface AvatarValidationErrorsDto {
  background_color?: null | AvatarValidationErrorCode;
  initials?: null | AvatarValidationErrorCode;
}

/**
 * Describes the application-level outcome for avatar config validation.
 */
export type AvatarValidationStatus =
  (typeof AvatarValidationStatus)[keyof typeof AvatarValidationStatus];

export const AvatarValidationStatus = {
  invalid_config: 'invalid_config',
} as const;

/**
 * Returns structured validation errors for avatar settings and preview requests.
 */
export interface AvatarValidationErrorResponse {
  /** Carries per-field avatar validation errors for the request. */
  errors: AvatarValidationErrorsDto;
  /** Identifies the application-level validation status. */
  status: AvatarValidationStatus;
  /** Distinguishes validation failures from successful avatar API responses. */
  success: boolean;
}

/**
 * Typed JSON alternatives returned when updating avatar settings.
 *
 * The response remains untagged because each variant already has a distinct,
 * frontend-facing object shape. Wrapping this enum in `Json` lets Axum perform
 * the response conversion while retaining a named response enum for future
 * schema generation.
 */
export type AvatarSettingsPatchOutcome = AvatarSettingsResponse | AvatarValidationErrorResponse;

export type OAuthProvider = (typeof OAuthProvider)[keyof typeof OAuthProvider];

export const OAuthProvider = {
  google: 'google',
  meta: 'meta',
} as const;

export interface CallbackRequest {
  oauth_code: string;
  provider: OAuthProvider;
  state: string;
}

export type OAuthIntent = (typeof OAuthIntent)[keyof typeof OAuthIntent];

export const OAuthIntent = {
  login: 'login',
  register: 'register',
  link_account: 'link_account',
} as const;

/**
 * OAuth identity information shared by registration and user-display APIs.
 */
export interface OAuthIdentityInfo {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  picture?: string | null;
  provider: OAuthProvider;
  provider_user_id: string;
}

export type OAuthResponseStatus = (typeof OAuthResponseStatus)[keyof typeof OAuthResponseStatus];

export const OAuthResponseStatus = {
  login_success: 'login_success',
  account_linked: 'account_linked',
  oauth_identity_conflict: 'oauth_identity_conflict',
  no_existing_account: 'no_existing_account',
  session_expired: 'session_expired',
  not_logged_in: 'not_logged_in',
  provider_mismatch: 'provider_mismatch',
  invalid_state: 'invalid_state',
  registration_required: 'registration_required',
} as const;

export interface UserInfo {
  /** @nullable */
  email?: string | null;
  is_new_user: boolean;
  /** @nullable */
  name?: string | null;
  username: string;
}

export interface CallbackResponse {
  intent: OAuthIntent;
  /** @nullable */
  invite_code?: string | null;
  oauth_identity?: null | OAuthIdentityInfo;
  provider: OAuthProvider;
  status: OAuthResponseStatus;
  user_info?: null | UserInfo;
}

/**
 * Requests owner-scoped cancellation by invitation identity.
 */
export interface CancelInviteRequest {
  invite_id: number;
}

/**
 * Public document identifier used in API communication with the frontend.
 * This is a UUID that maps to an internal `DocId`.
 */
export type PublicDocId = string & { readonly __brand: 'PublicDocId' };

/**
 * User action when voting on a document.
 *
 * This enum represents what the user explicitly did: upvote, downvote, or remove
 * their existing vote. It is used in API requests and stored in the database.
 */
export type VoteAction = (typeof VoteAction)[keyof typeof VoteAction];

export const VoteAction = {
  upvote: 'upvote',
  downvote: 'downvote',
  remove: 'remove',
} as const;

/**
 * Request body for POST /doc/vote.
 */
export interface CastVoteRequest {
  doc_id: PublicDocId;
  /** The action: "upvote", "downvote", or "remove" */
  vote_action: VoteAction;
}

/**
 * Status codes for cast vote operations.
 */
export type CastVoteStatus = (typeof CastVoteStatus)[keyof typeof CastVoteStatus];

export const CastVoteStatus = {
  success: 'success',
  rate_limited: 'rate_limited',
  self_vote_not_allowed: 'self_vote_not_allowed',
  doc_not_found: 'doc_not_found',
} as const;

/**
 * Current vote state on a document (Up or Down).
 *
 * This represents the current state of a user's vote, not the action they took.
 * Use `Option<VoteState>` to represent "no vote" (None).
 */
export type VoteState = (typeof VoteState)[keyof typeof VoteState];

export const VoteState = {
  up: 'up',
  down: 'down',
} as const;

/**
 * Vote info safe for any authenticated user's API response.
 * Shows the net score and the requesting user's own vote state (if any).
 */
export interface DisclosedVoteInfo {
  score: number;
  user_vote: null | VoteState;
}

/**
 * Response for POST /doc/vote.
 */
export interface CastVoteResponse {
  status: CastVoteStatus;
  vote_info?: null | DisclosedVoteInfo;
}

export interface CheckUsernameRequest {
  username: string;
}

export interface CheckUsernameResponse {
  available: boolean;
}

/**
 * The nature of reference or response between two docs.
 *
 * TODO(3): Standardizing the relation names in `docs.citations` to
 * `snake_case` requires a database migration.
 *
 * TODO(3): reconcile this with the discourse act constants.
 */
export type CitationRelation = (typeof CitationRelation)[keyof typeof CitationRelation];

export const CitationRelation = {
  reply_to: 'reply_to',
  Critique: 'Critique',
  Summarize: 'Summarize',
  Revise: 'Revise',
  Answer: 'Answer',
  SummarizeThread: 'SummarizeThread',
  SummarizeSource: 'SummarizeSource',
} as const;

export type DisplayImageCdn = (typeof DisplayImageCdn)[keyof typeof DisplayImageCdn];

export const DisplayImageCdn = {
  amazon: 'amazon',
  walmart: 'walmart',
  shopify: 'shopify',
  static: 'static',
} as const;

export interface DisplayImage {
  cdn: DisplayImageCdn;
  url: string;
}

export interface DisplayConceptRef {
  /** The concept reference */
  cref: string;
  /** A description of the concept, e.g. for tooltips */
  description: string;
  /** A display name for the concept */
  display: string;
  /** Indicates if this concept is an offer (SKU) */
  is_offer: boolean;
  /**
   * How this concept was mentioned in text (if applicable)
   * @nullable
   */
  mention?: string | null;
  preview_image?: null | DisplayImage;
}

export interface DisplayCitation {
  doc: PublicDocId;
  rel: CitationRelation;
}

/**
 * Serializable avatar URL shown in frontend user views.
 */
export interface DisplayAvatar {
  /**
   * TODO(2): Evaluate whether this should use a dedicated non-string path/URL type.
   * Points to the user's effective avatar endpoint.
   */
  url: string;
}

/**
 * API-facing document author metadata shared with the frontend `DisplayDoc` contract.
 */
export interface DisplayProvenance {
  avatar?: null | DisplayAvatar;
  /** Stores when the document was created. */
  createdon: string;
  /** Stores the display creator label, which is either a username or `AI_CREATOR`. */
  creator: string;
}

/**
 * Inline elements within a block
 */
export type InlineElement =
  | {
      content: string;
      type: 'text';
    }
  | {
      cref: string;
      text: InlineElement[];
      type: 'concept_link';
    }
  | {
      text: InlineElement[];
      /** @nullable */
      title: string | null;
      type: 'link';
      url: string;
    }
  | {
      alt: string;
      /** @nullable */
      title: string | null;
      type: 'image';
      url: string;
    }
  | {
      content: InlineElement[];
      type: 'emphasis';
    }
  | {
      content: InlineElement[];
      type: 'strong';
    }
  | {
      content: string;
      type: 'code';
    }
  | {
      type: 'line_break';
    }
  | {
      type: 'soft_break';
    };

/**
 * @minimum 1
 * @maximum 6
 */
export type HeadingLevel = number;

/**
 * List item (can contain nested blocks)
 */
export interface ListItem {
  blocks: ContentBlock[];
}

/**
 * Table cell containing inline elements
 */
export interface TableCell {
  inline_elements: InlineElement[];
}

/**
 * Table row
 */
export interface TableRow {
  cells: TableCell[];
}

/**
 * The destination represented by an offer comparison row.
 *
 * Only validated concept references and HTTP(S) URLs may be stored here.
 */
export type OfferComparisonTarget =
  | {
      cref: string;
      kind: 'concept_ref';
    }
  | {
      kind: 'external_url';
      url: string;
    };

/**
 * A row in an offer comparison table.
 */
export interface OfferComparisonRow {
  /** The LLM's commentary about this offer */
  comments: string;
  /** The display name for the offer */
  offer_name: string;
  /** The internal concept reference or external HTTP(S) destination. */
  target: OfferComparisonTarget;
}

/**
 * A block of content in the document
 */
export type ContentBlock =
  | {
      inline_elements: InlineElement[];
      type: 'paragraph';
    }
  | {
      inline_elements: InlineElement[];
      level: HeadingLevel;
      type: 'heading';
    }
  | {
      items: ListItem[];
      ordered: boolean;
      type: 'list';
    }
  | {
      headers: TableRow;
      rows: TableRow[];
      type: 'table';
    }
  | {
      rows: OfferComparisonRow[];
      type: 'offer_comparison_table';
    }
  | {
      blocks: ContentBlock[];
      type: 'block_quote';
    }
  | {
      code: string;
      /** @nullable */
      language: string | null;
      type: 'code_block';
    }
  | {
      type: 'thematic_break';
    };

/**
 * Represents a structured document that can contain markdown elements and other
 * application-specific components.
 *
 * Eventually this should support many components and document structures and subsume the use
 * of raw markdown as the document format, and can be used as the native storage format.  For
 * now, this is a run-time structure that is parsed from special markdown patterns in the
 * raw markdown which is currently persisted.
 */
export interface StructuredDocContent {
  blocks: ContentBlock[];
}

/**
 * API-facing visibility enum for documents.
 * IMPORTANT: This is for API communication only. Do NOT use in DB layer.
 * Convert to/from `base::kb::docs::access::Visibility` at API boundaries.
 */
export type DocVisibility = (typeof DocVisibility)[keyof typeof DocVisibility];

export const DocVisibility = {
  public: 'public',
  friends: 'friends',
  private: 'private',
} as const;

export interface DisplayDoc {
  aspect?: null | DisplayConceptRef;
  citations: DisplayCitation[];
  id: PublicDocId;
  mentioned_concepts: DisplayConceptRef[];
  provenance: DisplayProvenance;
  structured_content?: null | StructuredDocContent;
  suggested_questions: string[];
  /**
   * Summary text for guide documents (optional)
   * @nullable
   */
  summary?: string | null;
  text: string;
  topic?: null | DisplayConceptRef;
  visibility: null | DocVisibility;
  vote_info?: null | DisclosedVoteInfo;
}

/**
 * A single observed price for an offer at a point in time, taken from one
 * provider offer snapshot.
 *
 * Assembled into a chronological timeseries by `compose()` (one point per
 * stored snapshot that carries a price) and surfaced on `Offer` via
 * `price_history()`. Used by the API layer to expose an offer's price history
 * to the frontend.
 */
export interface PricePoint {
  /**
   * The currency of `price`, when the snapshot reported one.
   * @nullable
   */
  currency: string | null;
  /** When this price was observed, from the snapshot's `extraction_date`. */
  date: string;
  /** The observed price. */
  price: number;
}

export interface DisplayOffer {
  buy_at_label: string;
  /** @nullable */
  category_path: string | null;
  /** @nullable */
  currency: string | null;
  /** @nullable */
  customer_rating: number | null;
  description: string;
  id: string;
  images: DisplayImage[];
  marketplace: string;
  /**
   * @minimum 0
   * @nullable
   */
  num_reviews: number | null;
  /** @nullable */
  offer_url: string | null;
  /** @nullable */
  orig_title: string | null;
  /** @nullable */
  price: number | null;
  /**
   * Chronological price observations (oldest first) assembled from the
   * offer's provider snapshots during composition. Empty when no priced
   * snapshots were available.
   */
  price_history: PricePoint[];
  /** @nullable */
  stock_status: string | null;
  tags: string[];
  title: string;
  vendor: string;
}

export interface CollectionsPayload {
  docs: DisplayDoc[];
  offers: DisplayOffer[];
}

export type ConceptRef = string;

/**
 * Requests one invitation from the authenticated user's available credits.
 */
export interface CreateInviteRequest {
  invitee_topics: string[];
  inviter_topics: string[];
  /** @nullable */
  nickname?: string | null;
  thread_context?: null | PublicDocId;
}

/**
 * One currently usable invitation returned to its owner.
 */
export interface PendingInviteResponse {
  code: string;
  created_at: string;
  id: number;
  invitee_nickname: string;
  thread_context?: null | PublicDocId;
}

/**
 * Expected outcomes from invitation creation.
 */
export type CreateInviteResponse =
  | {
      invite: PendingInviteResponse;
      status: 'success';
    }
  | {
      status: 'no_credits';
    }
  | {
      status: 'email_verification_required';
    };

export interface Credentials {
  password: string;
  username: string;
}

export type DefaultPlaceholderAvatarConfigDto = ClosedEmptyObject;

/**
 * Request for account deletion
 */
export interface DeleteAccountRequest {
  [key: string]: unknown;
}

/**
 * Response for account deletion request
 */
export interface DeleteAccountResponse {
  status: string;
}

/**
 * Why a configured source is excluded from routing. The frontend uses the
 * generated counterpart to render these codes and the dependency identity.
 */
export type DisplaySourceSkipReason =
  (typeof DisplaySourceSkipReason)[keyof typeof DisplaySourceSkipReason];

export const DisplaySourceSkipReason = {
  unhealthy: 'unhealthy',
  not_capable: 'not_capable',
  required_fetcher_missing: 'required_fetcher_missing',
  required_fetcher_unhealthy: 'required_fetcher_unhealthy',
} as const;

/**
 * Three-level health state used by orchestrators for source selection.
 *
 * - `Healthy`: Normal operation, source is functioning well
 * - `Degraded`: Advisory state - try but prefer alternatives if available
 * - `Unhealthy`: Hard block - skip this source entirely
 */
export type HealthStatus = (typeof HealthStatus)[keyof typeof HealthStatus];

export const HealthStatus = {
  healthy: 'healthy',
  degraded: 'degraded',
  unhealthy: 'unhealthy',
} as const;

/**
 * Availability of one source considered by the routing layer.
 */
export interface DisplayRoutingEntry {
  excluded_reason?: null | DisplaySourceSkipReason;
  /**
   * Fetch source responsible for a dependency exclusion, when applicable.
   * @nullable
   */
  required_fetch_source?: string | null;
  source: string;
  status: HealthStatus;
}

/**
 * Source routing decisions for one catalog.
 */
export interface DisplayCatalogRouting {
  active_sources: DisplayRoutingEntry[];
  catalog: string;
  excluded_sources: DisplayRoutingEntry[];
}

/**
 * Event types for API health tracking, shared across all sources.
 *
 * Sources record these events as API calls complete. The tracker
 * maintains event history to compute error rates, and certain events
 * (Auth, `RateLimited`) trigger cooldown periods.
 */
export type HealthEvent = (typeof HealthEvent)[keyof typeof HealthEvent];

export const HealthEvent = {
  ok: 'ok',
  timeout: 'timeout',
  network: 'network',
  parse_fail: 'parse_fail',
  rate_limited: 'rate_limited',
  auth: 'auth',
  server5xx: 'server5xx',
  client4xx: 'client4xx',
  other: 'other',
} as const;

/**
 * A single health event with its timestamp, for inclusion in reports.
 */
export interface TimestampedHealthEvent {
  event: HealthEvent;
  time: string;
}

/**
 * Snapshot of current health metrics from a `HealthTracker`.
 */
export interface HealthMetrics {
  /** @minimum 0 */
  error_events: number;
  error_rate: number;
  is_blocked: boolean;
  /** Up to 20 most recent events, newest first. */
  recent_events: TimestampedHealthEvent[];
  status: HealthStatus;
  /** @minimum 0 */
  total_events: number;
}

/**
 * Health metrics for one configured search or fetch source.
 */
export interface DisplayClientHealthReport {
  metrics: HealthMetrics;
  /** Stable source identity used by routing and health tracking. */
  source: string;
}

export interface DisplayCollection {
  docs: PublicDocId[];
  name: string;
  offers: DisplayConceptRef[];
}

/**
 * Source routing decisions for one marketplace.
 */
export interface DisplayMarketplaceRouting {
  active_sources: DisplayRoutingEntry[];
  excluded_sources: DisplayRoutingEntry[];
  marketplace: string;
  unavailable: boolean;
}

/**
 * Aggregate health counts across clients.
 */
export interface HealthTotals {
  /** @minimum 0 */
  degraded: number;
  /** @minimum 0 */
  healthy: number;
  /** @minimum 0 */
  total_clients: number;
  /** @minimum 0 */
  unhealthy: number;
}

/**
 * Complete health and routing snapshot for one search orchestrator.
 */
export interface DisplayOrchestratorHealth {
  catalog_routing?: DisplayCatalogRouting[];
  clients: DisplayClientHealthReport[];
  marketplace_routing?: DisplayMarketplaceRouting[];
  orchestrator: string;
  totals: HealthTotals;
}

/**
 * @nullable
 */
export type DisplayUserOauthIdentities = { [key: string]: OAuthIdentityInfo } | null;

export interface DisplayUserFollow {
  avatar: DisplayAvatar;
  topics: DisplayConceptRef[];
  username: string;
}

/**
 * The marketplace where offers are sold.
 *
 * This is distinct from `OfferProvider` (data source like Amazon PA-API or `BrightData`)
 * and `ExternalIdSpace` (ID-space like ASIN or Walmart Item ID).
 * Multiple providers can serve the same marketplace.
 */
export type Marketplace = (typeof Marketplace)[keyof typeof Marketplace];

export const Marketplace = {
  amazon: 'amazon',
  walmart: 'walmart',
  shopify: 'shopify',
  ebay: 'ebay',
} as const;

/**
 * Specifies which marketplaces to search.
 *
 * Used to filter which marketplaces participate in a search. The actual
 * marketplaces searched are the intersection of this affinity and the
 * orchestrator's configured (available) sources.
 *
 * - preferred: when non-empty, specifies marketplaces to try first; others are available as fallback
 * - avoided: always a hard deny-list subtracted from the base set
 * - Invariant: a marketplace cannot be both preferred and avoided (enforced by `try_new`)
 *
 * The orchestrator tries preferred marketplaces first, falling back to neutral (non-preferred,
 * non-avoided) marketplaces if preferred ones are unavailable. Avoided marketplaces are never used.
 */
export interface MarketplaceAffinity {
  avoided: Marketplace[];
  preferred: Marketplace[];
}

/**
 * API-facing password states shown in the account UI.
 *
 * The persisted `base::kb::user::PasswordState` contains reset-token details that
 * must never cross this API boundary.
 */
export type PasswordStateDto = (typeof PasswordStateDto)[keyof typeof PasswordStateDto];

export const PasswordStateDto = {
  user_set: 'user_set',
  system_generated: 'system_generated',
  temporary: 'temporary',
  reset_required: 'reset_required',
  reset_initiated: 'reset_initiated',
} as const;

/**
 * API-facing profile discoverability enum. Synced with `base::kb::user::ProfileDiscoverability`.
 * IMPORTANT: This is for API communication only. Convert to/from base enum at API boundaries.
 */
export type ProfileDiscoverability =
  (typeof ProfileDiscoverability)[keyof typeof ProfileDiscoverability];

export const ProfileDiscoverability = {
  public: 'public',
  connections: 'connections',
  private: 'private',
} as const;

/**
 * Public user identifier used in API communication with the frontend.
 *
 * Wraps `User::public_id`: safe to expose and, unlike username or email, stable for the
 * account's life, so the frontend keys users on it, including for analytics. Needs no
 * translation, since `User` carries it.
 */
export type PublicUserId = string & { readonly __brand: 'PublicUserId' };

export interface DisplayUser {
  avatar: DisplayAvatar;
  collections: DisplayCollection[];
  email: string;
  followed_topics: DisplayConceptRef[];
  followed_users: DisplayUserFollow[];
  fullname: string;
  has_been_welcomed: boolean;
  has_password_auth: boolean;
  has_set_password: boolean;
  is_admin: boolean;
  link: string;
  marketplace_preference: MarketplaceAffinity;
  may_invite: boolean;
  /** @nullable */
  oauth_identities?: DisplayUserOauthIdentities;
  password_state: PasswordStateDto;
  /**
   * The user's unverified replacement email, if one is currently awaiting confirmation.
   * @nullable
   */
  pending_email?: string | null;
  profile_discoverability: ProfileDiscoverability;
  /** Stable account identifier; unlike `username` and `email`, it never changes. */
  public_id: PublicUserId;
  username: string;
}

/**
 * A post excerpt published through the generated HTTP contract.
 */
export interface DocSearchResult {
  /** Public identifier used to open the matching post's discussion. */
  doc_id: PublicDocId;
  /** Plain match or opening-document context. Render as text, never as trusted HTML. */
  excerpt: string;
  /** Author and creation time of the matching post. */
  provenance: DisplayProvenance;
}

/**
 * Explains why a submitted email cannot be represented by the supported address format.
 */
export type EmailUnsupportedReasonDto =
  (typeof EmailUnsupportedReasonDto)[keyof typeof EmailUnsupportedReasonDto];

export const EmailUnsupportedReasonDto = {
  empty: 'empty',
  multiple_addresses: 'multiple_addresses',
  display_name_or_angle_address: 'display_name_or_angle_address',
  comments_or_cfws: 'comments_or_cfws',
  quoted_local_part: 'quoted_local_part',
  non_ascii: 'non_ascii',
  internal_whitespace: 'internal_whitespace',
  missing_at_sign: 'missing_at_sign',
  multiple_at_signs: 'multiple_at_signs',
  invalid_local_part: 'invalid_local_part',
  invalid_domain: 'invalid_domain',
  domain_literal: 'domain_literal',
} as const;

/**
 * A reason for why something is in the feed.  This would actually
 * be a bit more naturally expressed as an enum, but structs are
 * simpler to serialize to the frontend, and having lots of Option
 * fields allows multiple reasons to be expressed simultaneously.
 */
export interface FeedItemJustification {
  aspect: null | DisplayConceptRef;
  /** @nullable */
  friend: string | null;
  is_owned: boolean;
  /**
   * Paragraph containing the explicit viewer mention.
   * @nullable
   */
  mention_paragraph?: string | null;
  /** @nullable */
  mentioner: string | null;
  topic: null | DisplayConceptRef;
}

/**
 * One actionable feed-level follow-up question published through `OpenAPI`.
 */
export interface FeedItemSuggestedQuestion {
  /** Public identity of the document that supplied the question. */
  source_doc_id: PublicDocId;
  /** Text posted when the viewer chooses this question. */
  text: string;
  /**
   * Topic inherited from the same source document when present.
   * @nullable
   */
  topic_cref?: string | null;
}

/**
 * One document-thread node; generated wire tags use `snake_case`.
 */
export type ThreadNode =
  | {
      /** Existing complete display projection. */
      doc: DisplayDoc;
      kind: 'document';
      parent_public_doc_id: null | PublicDocId;
      /** Public identity shared with the inaccessible variant. */
      public_doc_id: PublicDocId;
    }
  | {
      kind: 'inaccessible';
      parent_public_doc_id: null | PublicDocId;
      /** Public identity needed for topology and permalinks. */
      public_doc_id: PublicDocId;
    };

/**
 * Chronological document-thread response published through the generated contract.
 */
export interface ThreadResponse {
  /** Chronological disclosed and inaccessible structural nodes. */
  nodes: ThreadNode[];
  /** Public identity of the route target, including when that target is inaccessible. */
  target_public_doc_id: PublicDocId;
}

/**
 * One item in a feed. Currently built for putting threads in a feed, but could be
 * extended to other types of items.
 */
export interface FeedItem {
  creators: string[];
  /** @nullable */
  datetime: string | null;
  justification: FeedItemJustification;
  offers: DisplayOffer[];
  public_review_id?: null | PublicDocId;
  suggested_questions: FeedItemSuggestedQuestion[];
  summary?: null | DisplayDoc;
  /** Chronological readable and inaccessible thread window. */
  thread: ThreadResponse;
  topics: DisplayConceptRef[];
}

/**
 * Stores optional structured metadata for the breadcrumb.
 * @nullable
 */
export type FeedbackBreadcrumbDetail = { [key: string]: unknown } | null;

/**
 * Categories used to group captured browser events.
 */
export type FeedbackBreadcrumbKind =
  (typeof FeedbackBreadcrumbKind)[keyof typeof FeedbackBreadcrumbKind];

export const FeedbackBreadcrumbKind = {
  navigation: 'navigation',
  action: 'action',
  notification: 'notification',
  error: 'error',
} as const;

/**
 * Lifecycle states captured on action breadcrumbs.
 */
export type FeedbackBreadcrumbOutcome =
  (typeof FeedbackBreadcrumbOutcome)[keyof typeof FeedbackBreadcrumbOutcome];

export const FeedbackBreadcrumbOutcome = {
  pending: 'pending',
  success: 'success',
  failure: 'failure',
} as const;

/**
 * One browser event captured before the user submitted feedback.
 */
export interface FeedbackBreadcrumb {
  /**
   * Stores optional structured metadata for the breadcrumb.
   * @nullable
   */
  detail?: FeedbackBreadcrumbDetail;
  /**
   * Stores the frontend's stable client-local breadcrumb identifier.
   *
   * The canonical `feedback.json` attachment preserves this identifier for
   * machine consumers, while the human-readable formatter omits it.
   */
  id: string;
  /** Stores the breadcrumb category. */
  kind: FeedbackBreadcrumbKind;
  /** Stores the fixed breadcrumb label. */
  label: string;
  outcome?: null | FeedbackBreadcrumbOutcome;
  /** Stores the breadcrumb timestamp in milliseconds since epoch. */
  ts: number;
}

/**
 * Active browser color scheme when feedback was submitted.
 */
export type FeedbackColorScheme = (typeof FeedbackColorScheme)[keyof typeof FeedbackColorScheme];

export const FeedbackColorScheme = {
  light: 'light',
  dark: 'dark',
} as const;

/**
 * Browser environment captured with a feedback report.
 */
export interface FeedbackEnvironment {
  /** Stores the current color-scheme mode. */
  color_scheme: FeedbackColorScheme;
  /** Stores the submitting browser's user agent. */
  user_agent: string;
  /**
   * Stores the viewport height in CSS pixels.
   * @minimum 0
   */
  viewport_h: number;
  /**
   * Stores the viewport width in CSS pixels.
   * @minimum 0
   */
  viewport_w: number;
}

/**
 * Identifies the home-feed variant visible when feedback was opened.
 */
export type FeedbackFeedEndpoint = (typeof FeedbackFeedEndpoint)[keyof typeof FeedbackFeedEndpoint];

export const FeedbackFeedEndpoint = {
  public: 'public',
  unified: 'unified',
} as const;

/**
 * Sanitized browser route captured with a feedback report.
 */
export interface FeedbackRoute {
  /** Stores the current pathname. */
  pathname: string;
  /** Stores the allowlisted query string. */
  search: string;
}

/**
 * Describes the application surface visible when feedback was opened.
 */
export type FeedbackScene =
  | {
      kind: 'doc_thread';
      /**
       * Stores the thread's resolved main topic, if known.
       * @nullable
       */
      main_topic?: string | null;
      /** Stores the public thread identifier. */
      thread_id: PublicDocId;
    }
  | {
      /** Stores which feed variant the user was viewing. */
      endpoint: FeedbackFeedEndpoint;
      kind: 'home_feed';
    }
  | {
      kind: 'product_page';
      /** Stores the product reference shown on the page. */
      product_ref: string;
    }
  | {
      kind: 'guide_page';
      /** Stores the guide topic key shown on the page. */
      topic_key: string;
    }
  | {
      kind: 'unknown';
    };

/**
 * Identifies the entity the feedback concerns.
 */
export type FeedbackTarget =
  | {
      /** Stores the public document identifier. */
      id: PublicDocId;
      kind: 'doc';
    }
  | {
      /** Stores the public feed-item identifier. */
      id: PublicDocId;
      kind: 'feed_item';
    }
  | {
      kind: 'product';
      /** Stores the product reference. */
      product_ref: string;
    }
  | {
      kind: 'topic';
      /** Stores the topic key. */
      topic_key: string;
    };

/**
 * Describes how the user opened the feedback flow.
 */
export type FeedbackTrigger = (typeof FeedbackTrigger)[keyof typeof FeedbackTrigger];

export const FeedbackTrigger = {
  downvote_auto: 'downvote_auto',
  flag: 'flag',
  menu: 'menu',
} as const;

/**
 * Positive invitation-credit quantity granted by an administrator.
 */
export interface GrantInviteCreditsRequest {
  quantity: number;
}

/**
 * Successful response from GET `/health`.
 */
export interface HealthCheckResponse {
  environment: string;
  source_dirty: boolean;
  status: string;
  version: string;
}

/**
 * Health state for the external integrations exposed through the generated contract.
 */
export interface IntegrationHealthReport {
  fetch?: null | DisplayOrchestratorHealth;
  generated_at: string;
  search?: null | DisplayOrchestratorHealth;
}

export interface InterestSearchRequest {
  /**
   * @minimum 0
   * @nullable
   */
  limit?: number | null;
  topic_ids: string[];
}

/**
 * Minimal live credit state used by the administration UI.
 */
export interface InviteCreditSummaryResponse {
  credits_remaining: number;
  /** @nullable */
  credits_requested_at: string | null;
  /** @nullable */
  full_name: string | null;
  username: string;
}

/**
 * Current invitation state for the authenticated user.
 */
export interface InviteDashboardResponse {
  credits_remaining: number;
  /** @nullable */
  credits_requested_at: string | null;
  pending_invites: PendingInviteResponse[];
}

/**
 * Type of offer post to create (review or question)
 */
export type OfferPostType = (typeof OfferPostType)[keyof typeof OfferPostType];

export const OfferPostType = {
  review: 'review',
  question: 'question',
} as const;

/**
 * Request to create a new document
 */
export interface NewDocRequest {
  citation?: null | PublicDocId;
  /** Content of the document */
  content: string;
  post_type?: null | OfferPostType;
  /**
   * Topic of the document (optional)
   * @nullable
   */
  topic?: string | null;
  /** Explicitly chosen visibility specification for the new document. */
  visibility?: DocVisibility;
}

/**
 * Successful response from POST `/doc/new`.
 */
export interface NewDocResponse {
  /** Public identifier of the newly created document. */
  doc_id: PublicDocId;
}

export interface OAuthUrlResponse {
  authorization_url: string;
}

export interface PasswordCheckRequest {
  password: string;
}

export interface PasswordCheckResponse {
  is_acceptable: boolean;
  strength: number;
}

/**
 * Carries avatar source selection and config updates from the frontend.
 */
export interface PatchAvatarSettingsRequest {
  /** Includes any per-source configuration updates to persist. */
  configs?: AvatarSettingsPatchConfigsDto;
  selected?: null | AvatarSourceDto;
}

/**
 * Field-restricted projection of the same concept represented by `DisplayConceptRef`.
 *
 * This is not a distinct domain object. Its separate type freezes the anonymous
 * field allowlist and requires explicit review before exposing another display field.
 */
export interface PublicReviewConcept {
  /** Identifies the mentioned concept. */
  cref: string;
  /** Carries descriptive tooltip text when available. */
  description: string;
  /** Carries the concept's display label. */
  display: string;
  /** Identifies offer concepts for public offer-detail support fetches. */
  is_offer: boolean;
  preview_image?: null | DisplayImage;
}

/**
 * Field-restricted projection of the same topic represented by `DisplayConceptRef`.
 *
 * This is not a distinct domain object. Its separate type freezes the anonymous
 * field allowlist so broad display fields cannot enter the response implicitly.
 */
export interface PublicReviewTopic {
  /** Identifies the reviewed topic or product. */
  cref: string;
  /** Carries the display label shown on the review page. */
  display: string;
  preview_image?: null | DisplayImage;
}

/**
 * Field-restricted projection of the same document represented by `DisplayDoc`.
 *
 * This is not a distinct domain object. Its separate type constrains the anonymous
 * response so broad document fields cannot enter it implicitly.
 */
export interface PublicReviewProjection {
  /** Identifies the reviewed document at the public API boundary. */
  id: PublicDocId;
  /** Carries concepts needed by the structured renderer. */
  mentioned_concepts: PublicReviewConcept[];
  /** Carries display-safe author and creation metadata. */
  provenance: DisplayProvenance;
  /** Carries the full structured review body. */
  structured_content: StructuredDocContent;
  topic?: null | PublicReviewTopic;
}

/**
 * Public profile view with filtered data for discoverable users.
 */
export interface PublicUserProfile {
  avatar: DisplayAvatar;
  followed_topics: DisplayConceptRef[];
  followed_users: DisplayUserFollow[];
  follows_me: boolean;
  fullname: string;
  i_follow: boolean;
  mutual: boolean;
  username: string;
}

/**
 * One concept judgment within a recon relation bucket.
 */
export interface ReconJudgmentEntry {
  /** Identifies the judgment creator when provenance is available. */
  creator: string;
  /** Identifies the concept related to the requested concept. */
  other: string;
}

/**
 * Deterministic relation buckets returned by GET `/recon/{refs}`.
 */
export interface ReconInfoResponse {
  /** Judgments identifying distinct concepts. */
  different: ReconJudgmentEntry[];
  /** Judgments identifying disjoint concepts. */
  disjoint: ReconJudgmentEntry[];
  /** Judgments mapping another concept to the requested concept. */
  mapped_from: ReconJudgmentEntry[];
  /** Judgments mapping the requested concept to another concept. */
  maps_to: ReconJudgmentEntry[];
  /** Judgments whose relation does not match a named structural bucket. */
  other: ReconJudgmentEntry[];
  /** Judgments identifying overlapping concepts. */
  overlap: ReconJudgmentEntry[];
  /** Judgments identifying subclasses of the requested concept. */
  subclass: ReconJudgmentEntry[];
  /** Judgments identifying superclasses of the requested concept. */
  superclass: ReconJudgmentEntry[];
}

/**
 * Application outcomes returned by POST `/auth/register`.
 */
export type RegistrationResponse =
  | {
      status: 'success';
    }
  | {
      status: 'verification_email_send_failed';
    }
  | {
      reason: EmailUnsupportedReasonDto;
      status: 'unsupported_format';
    }
  | {
      status: 'username_invalid';
      username: string;
    }
  | {
      status: 'username_taken';
      username: string;
    }
  | {
      status: 'invalid_invite_code';
    }
  | {
      status: 'password_insecure';
    }
  | {
      status: 'password_mismatch';
    }
  | {
      status: 'email_mismatch';
    }
  | {
      status: 'password_required';
    }
  | {
      status: 'email_required';
    }
  | {
      /** @nullable */
      email?: string | null;
      status: 'email_already_in_use';
    };

/**
 * Request to remove an OAuth identity from the user's account
 */
export interface RemoveOAuthIdentityRequest {
  provider: OAuthProvider;
  provider_user_id: string;
}

export interface RequestPasswordResetRequest {
  email: string;
}

export type RequestPasswordResetStatus =
  (typeof RequestPasswordResetStatus)[keyof typeof RequestPasswordResetStatus];

export const RequestPasswordResetStatus = {
  accepted: 'accepted',
  unsupported_format: 'unsupported_format',
} as const;

export interface RequestPasswordResetResponse {
  accepted: boolean;
  reason?: null | EmailUnsupportedReasonDto;
  status: RequestPasswordResetStatus;
}

/**
 * Application-level outcomes for resending the current pending email verification.
 */
export type ResendEmailVerificationStatus =
  (typeof ResendEmailVerificationStatus)[keyof typeof ResendEmailVerificationStatus];

export const ResendEmailVerificationStatus = {
  verification_email_sent: 'verification_email_sent',
  no_pending_verification: 'no_pending_verification',
} as const;

/**
 * Response body returned after resending a pending email verification.
 */
export interface ResendEmailVerificationResponse {
  status: ResendEmailVerificationStatus;
  success: boolean;
}

export interface ResetPasswordRequest {
  new_password: string;
  token: string;
}

export type ResetPasswordStatus = (typeof ResetPasswordStatus)[keyof typeof ResetPasswordStatus];

export const ResetPasswordStatus = {
  success: 'success',
  invalid_token: 'invalid_token',
  expired_token: 'expired_token',
  password_insecure: 'password_insecure',
} as const;

export interface ResetPasswordResponse {
  /** @nullable */
  score?: number | null;
  status: ResetPasswordStatus;
  success: boolean;
}

/**
 * Frontend projection returned by GET `/schema/{refs}` and exported through `OpenAPI`.
 */
export interface SchemaConceptResponse {
  /** Natural-language concept description. */
  description: string;
  /** Human-readable concept name. */
  display_name: string;
  /** Canonical concept reference. */
  key: string;
  /** Displayable child concepts. */
  sub: string[];
  /** Displayable parent concepts. */
  sup: string[];
}

/**
 * Sets whether the authenticated user has dismissed the home welcome card.
 */
export interface SetUserWelcomedRequest {
  /** False makes the welcome card appear again; true records its dismissal. */
  has_been_welcomed: boolean;
}

/**
 * Application-level outcomes for abandoning the current pending email verification.
 */
export type StopEmailVerificationStatus =
  (typeof StopEmailVerificationStatus)[keyof typeof StopEmailVerificationStatus];

export const StopEmailVerificationStatus = {
  pending_verification_stopped: 'pending_verification_stopped',
  no_pending_verification: 'no_pending_verification',
} as const;

/**
 * Response body returned after stopping a pending email verification.
 */
export interface StopEmailVerificationResponse {
  status: StopEmailVerificationStatus;
  success: boolean;
}

/**
 * Request body for `POST /feedback/submit`.
 *
 * Tag policy: tag *values* are intentionally NOT part of the API contract. The
 * frontend owns the tag taxonomy (`frontend/src/feedback/ontology/tags.ts`) and
 * the backend records whatever tags it receives verbatim, without validating or
 * constraining the values. Only the list-of-strings shape is contractual. This
 * deliberately avoids coupling the frontend and backend tag vocabularies, so new
 * tags can be added on the frontend alone.
 */
export interface SubmitFeedbackRequest {
  /** Stores the captured breadcrumb trail from the frontend. */
  breadcrumbs: FeedbackBreadcrumb[];
  /** Stores the captured browser environment from the frontend. */
  env: FeedbackEnvironment;
  /** Stores the freeform feedback message, which may be empty. */
  message: string;
  /** Stores the captured route details from the frontend. */
  route: FeedbackRoute;
  /** Stores the surface the user was on when feedback opened. */
  scene: FeedbackScene;
  /**
   * Free-form tags the user selected. Values are frontend-defined and recorded
   * verbatim; the backend does not validate or constrain them.
   */
  tags: string[];
  target?: null | FeedbackTarget;
  /** Records how the user opened the feedback flow. */
  trigger: FeedbackTrigger;
  /**
   * Free-form tags that were offered to the user but not selected; recorded
   * verbatim, values not validated.
   */
  unselected_tags: string[];
}

/**
 * Application-level status codes for `POST /feedback/submit`.
 */
export type SubmitFeedbackStatus = (typeof SubmitFeedbackStatus)[keyof typeof SubmitFeedbackStatus];

export const SubmitFeedbackStatus = {
  success: 'success',
} as const;

/**
 * Response body for `POST /feedback/submit`.
 */
export interface SubmitFeedbackResponse {
  /** Stores the application-level submission status. */
  status: SubmitFeedbackStatus;
}

/**
 * Successful status shared by endpoints that only acknowledge completion.
 */
export type SuccessStatus = (typeof SuccessStatus)[keyof typeof SuccessStatus];

export const SuccessStatus = {
  success: 'success',
} as const;

/**
 * Flat successful response shared by authentication acknowledgement endpoints.
 */
export interface SuccessResponse {
  status: SuccessStatus;
}

/**
 * A search conversation published through the generated HTTP contract.
 */
export interface ThreadSearchResult {
  /** Highest-ranked visible match, used to order and open the conversation. */
  best_match: DocSearchResult;
  opening_doc: null | DocSearchResult;
  /** Additional visible matches in relevance order, bounded rather than exhaustive. */
  other_matches: DocSearchResult[];
}

/**
 * A single topic entry in a thread's table of contents
 */
export interface ThreadTopicEntry {
  /** The id of the document that initiated this topic */
  doc_id: PublicDocId;
  /** A 3-6 word summary of the topic */
  summary: string;
}

/**
 * Table of contents for a thread
 */
export interface ThreadTableOfContents {
  /** The major topics/themes in the thread */
  topics: ThreadTopicEntry[];
}

/**
 * Successful trigger-reply status.
 */
export type TriggerReplyStatus = (typeof TriggerReplyStatus)[keyof typeof TriggerReplyStatus];

export const TriggerReplyStatus = {
  triggered: 'triggered',
} as const;

/**
 * Successful response from POST `/doc/trigger_reply/{docid}`.
 */
export interface TriggerReplyResponse {
  doc_id: PublicDocId;
  status: TriggerReplyStatus;
}

export type UpdateCollections = (typeof UpdateCollections)[keyof typeof UpdateCollections];

export const UpdateCollections = {
  add: 'add',
  remove: 'remove',
} as const;

export interface UpdateCollectionRequest {
  action: UpdateCollections;
  docs: PublicDocId[];
  name: string;
  offers: string[];
}

/**
 * Request to update user's profile discoverability setting
 */
export interface UpdateDiscoverabilityRequest {
  discoverability: ProfileDiscoverability;
}

/**
 * Request body for starting a pending email verification for the authenticated user.
 */
export interface UpdateEmailRequest {
  new_email: string;
}

/**
 * Application-level outcomes for starting a pending email verification.
 */
export type UpdateEmailStatus = (typeof UpdateEmailStatus)[keyof typeof UpdateEmailStatus];

export const UpdateEmailStatus = {
  pending_verification_started: 'pending_verification_started',
  unsupported_format: 'unsupported_format',
  already_verified_by_you: 'already_verified_by_you',
  already_pending_for_you: 'already_pending_for_you',
  claimed_by_another_user: 'claimed_by_another_user',
  email_required: 'email_required',
} as const;

/**
 * Response body returned after attempting to start a pending email verification.
 */
export interface UpdateEmailResponse {
  reason?: null | EmailUnsupportedReasonDto;
  status: UpdateEmailStatus;
  success: boolean;
}

/**
 * follow setter requests
 */
export type UpdateFollowAction = (typeof UpdateFollowAction)[keyof typeof UpdateFollowAction];

export const UpdateFollowAction = {
  follow: 'follow',
  unfollow: 'unfollow',
  update: 'update',
} as const;

/**
 * A request to update follows, either `UserFollows` or `TopicFollows`.
 * If `username_to_follow` is empty, then the reuqested topics are added,
 * removed, or set as the user's `TopicFollows`, depending on `action`.
 * If `username_to_follow` is provided, then the user follow is added,
 * removed, or updated; the topics are used for new or updated follows
 * and ignored for removals.
 */
export interface UpdateFollowsRequest {
  action: UpdateFollowAction;
  topics?: string[];
  /** @nullable */
  username_to_follow?: string | null;
}

/**
 * Request to update the user's marketplace preference.
 */
export interface UpdateMarketplacePreferenceRequest {
  marketplace_preference: MarketplaceAffinity;
}

export interface UpdatePasswordRequest {
  new_password: string;
  old_password?: string;
}

/**
 * Minimal user search result safe for public display, with no sensitive data.
 */
export interface UserSearchResult {
  avatar: DisplayAvatar;
  follows_me: boolean;
  fullname: string;
  i_follow: boolean;
  mutual: boolean;
  shared_topics: DisplayConceptRef[];
  /** @minimum 0 */
  shared_topics_count: number;
  username: string;
}

/**
 * Fields required for registering a new user. Supports both password-based
 * and OAuth-based registration. These must match the JSON struct sent by frontend.
 */
export interface UserToCreate {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  email2?: string | null;
  /** @nullable */
  fullname?: string | null;
  invite_code: string;
  oauth_identity?: null | OAuthIdentityInfo;
  /** @nullable */
  password?: string | null;
  /** @nullable */
  password2?: string | null;
  username: string;
}

export interface ValidateInviteRequest {
  invite_code: string;
}

export interface ValidateInviteResponse {
  invite_code: string;
  invitee_topics: DisplayConceptRef[];
  inviter: string;
  inviter_topics: DisplayConceptRef[];
  thread_context?: null | PublicDocId;
}

export interface ValidateResetTokenRequest {
  token: string;
}

export type ValidateResetTokenStatus =
  (typeof ValidateResetTokenStatus)[keyof typeof ValidateResetTokenStatus];

export const ValidateResetTokenStatus = {
  valid: 'valid',
  invalid_token: 'invalid_token',
  expired_token: 'expired_token',
} as const;

export interface ValidateResetTokenResponse {
  status: ValidateResetTokenStatus;
  success: boolean;
}

/**
 * Request body for consuming an email verification token.
 */
export interface VerifyEmailRequest {
  token: string;
}

/**
 * Application-level outcomes for email verification token consumption.
 */
export type VerifyEmailStatus = (typeof VerifyEmailStatus)[keyof typeof VerifyEmailStatus];

export const VerifyEmailStatus = {
  success: 'success',
  invalid_token: 'invalid_token',
  expired_token: 'expired_token',
  email_already_in_use: 'email_already_in_use',
} as const;

/**
 * Response body returned after verifying or rejecting an email verification token.
 */
export interface VerifyEmailResponse {
  status: VerifyEmailStatus;
  success: boolean;
}

export type GetGuidesByTopic200 = { [key: string]: DisplayDoc };

export type SearchDocsParams = {
  /**
   * Word prefixes, quoted phrases, OR alternatives, and whole-word exclusions.
   */
  query: string;
  /**
   * Optional cap on distinct threads, clamped to the endpoint's supported range.
   * @minimum 0
   */
  limit?: number;
};

export type PrepareOauthParams = {
  provider: OAuthProvider;
  intent?: OAuthIntent;
  invite_code?: string;
};

/**
 * Returns structured validation errors for avatar settings and preview requests.
 */
export type PreviewAvatar200Two = {
  /** Carries per-field avatar validation errors for the request. */
  errors: AvatarValidationErrorsDto;
  /** Identifies the application-level validation status. */
  status: AvatarValidationStatus;
  /** Distinguishes validation failures from successful avatar API responses. */
  success: boolean;
};

export type GetUsersParams = {
  /**
   * Maximum number of users to return (defaults to 100, max 1000)
   * @minimum 0
   */
  limit?: number;
  /**
   * Number of users to skip (for pagination)
   * @minimum 0
   */
  offset?: number;
};

export type SearchUsersParams = {
  prefix: string;
  /**
   * @minimum 0
   */
  limit?: number;
};

export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx =
  | 400
  | 401
  | 402
  | 403
  | 404
  | 405
  | 406
  | 407
  | 408
  | 409
  | 410
  | 411
  | 412
  | 413
  | 414
  | 415
  | 416
  | 417
  | 418
  | 419
  | 420
  | 421
  | 422
  | 423
  | 424
  | 426
  | 428
  | 429
  | 431
  | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes =
  HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export const getGetInviteCreditSummariesUrl = () => {
  return `/admin/invite-credits`;
};

export const getInviteCreditSummaries = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<InviteCreditSummaryResponse[]> => {
  return orvalFetch<InviteCreditSummaryResponse[]>(getGetInviteCreditSummariesUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getCommitAdminSchemaJudgmentsUrl = () => {
  return `/admin/schema/judgments`;
};

/**
 * @summary Atomically persists an admin-authored batch without mutating live recon state.
 */
export const commitAdminSchemaJudgments = async (
  adminSchemaCommitJudgmentsRequest: AdminSchemaCommitJudgmentsRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<AdminSchemaCommitJudgmentsResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<AdminSchemaCommitJudgmentsResponse>(getCommitAdminSchemaJudgmentsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adminSchemaCommitJudgmentsRequest),
  });
};

export const getSearchAdminConceptsByPrefixUrl = (q: string) => {
  return `/admin/schema/prefix_search/${encodeURIComponent(String(q))}`;
};

/**
 * @summary Returns admin-only concept autocomplete results from the startup prefix snapshot.
 */
export const searchAdminConceptsByPrefix = async (
  q: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayConceptRef[]> => {
  return orvalFetch<DisplayConceptRef[]>(getSearchAdminConceptsByPrefixUrl(q), {
    ...options,
    method: 'GET',
  });
};

export const getGetAdminSchemaViewUrl = (refs: string) => {
  return `/admin/schema/view/${encodeURIComponent(String(refs))}`;
};

/**
 * @summary Returns a unified admin schema view for the requested cref.
This endpoint is admin-only and returns focus, equivalence, and composed sections.
 */
export const getAdminSchemaView = async (
  refs: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<AdminSchemaViewResponse> => {
  return orvalFetch<AdminSchemaViewResponse>(getGetAdminSchemaViewUrl(refs), {
    ...options,
    method: 'GET',
  });
};

export const getDeactivateUserUrl = (username: string) => {
  return `/admin/user/${encodeURIComponent(String(username))}/deactivate`;
};

/**
 * Marks the account deleted so it is hidden from listings/search and blocked
 * from authenticating, while its username and canonical email stay reserved.
 * Requires the caller to hold the `Admin` role. This is distinct from the
 * self-service `delete_account_request_handler`, which is left unchanged.
 * @summary Admin-only: deactivate (soft-delete) a user account by username.
 */
export const deactivateUser = async (
  username: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  return orvalFetch<DisplayUser>(getDeactivateUserUrl(username), {
    ...options,
    method: 'POST',
  });
};

export const getGrantInviteCreditsUrl = (username: string) => {
  return `/admin/user/${encodeURIComponent(String(username))}/invite-credits`;
};

export const grantInviteCredits = async (
  username: string,
  grantInviteCreditsRequest: GrantInviteCreditsRequest,
  options?: Parameters<typeof orvalNoContent>[1]
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalNoContent<void>(getGrantInviteCreditsUrl(username), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grantInviteCreditsRequest),
  });
};

export const getReactivateUserUrl = (username: string) => {
  return `/admin/user/${encodeURIComponent(String(username))}/reactivate`;
};

/**
 * Clears the account's deactivation so it becomes active again — visible in
 * listings and able to authenticate. Requires the caller to hold the `Admin`
 * role. Returns `404` if the named user is not currently deactivated.
 * @summary Admin-only: reactivate a previously deactivated user account.
 */
export const reactivateUser = async (
  username: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  return orvalFetch<DisplayUser>(getReactivateUserUrl(username), {
    ...options,
    method: 'POST',
  });
};

export const getCheckSessionUrl = () => {
  return `/auth/check`;
};

/**
 * @summary Used by login page to poll for session creation after successful
login.  Not sure, maybe can use `handlers::get_user` instead?
 */
export const checkSession = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<AuthCheckResponse> => {
  return orvalFetch<AuthCheckResponse>(getCheckSessionUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getCheckUsernameAvailabilityUrl = () => {
  return `/auth/check_username`;
};

/**
 * @summary Handler to check if a username is available
 */
export const checkUsernameAvailability = async (
  checkUsernameRequest: CheckUsernameRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<CheckUsernameResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<CheckUsernameResponse>(getCheckUsernameAvailabilityUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(checkUsernameRequest),
  });
};

export const getLoginUrl = () => {
  return `/auth/login`;
};

export const login = async (
  credentials: Credentials,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<SuccessResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<SuccessResponse>(getLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(credentials),
  });
};

export const getLogoutUrl = () => {
  return `/auth/logout`;
};

export const logout = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<SuccessResponse> => {
  return orvalFetch<SuccessResponse>(getLogoutUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getCheckPasswordStrengthUrl = () => {
  return `/auth/password_strength_check`;
};

/**
 * @summary Handler to check password strength dynamically
 */
export const checkPasswordStrength = async (
  passwordCheckRequest: PasswordCheckRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<PasswordCheckResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<PasswordCheckResponse>(getCheckPasswordStrengthUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(passwordCheckRequest),
  });
};

export const getRegisterUrl = () => {
  return `/auth/register`;
};

/**
 * @summary Unified registration handler that works with both password-based and OAuth-based registration
 */
export const register = async (
  userToCreate: UserToCreate,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<RegistrationResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<RegistrationResponse>(getRegisterUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userToCreate),
  });
};

export const getRequestPasswordResetUrl = () => {
  return `/auth/request_password_reset`;
};

export const requestPasswordReset = async (
  requestPasswordResetRequest: RequestPasswordResetRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<RequestPasswordResetResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<RequestPasswordResetResponse>(getRequestPasswordResetUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(requestPasswordResetRequest),
  });
};

export const getResetPasswordUrl = () => {
  return `/auth/reset_password`;
};

export const resetPassword = async (
  resetPasswordRequest: ResetPasswordRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ResetPasswordResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<ResetPasswordResponse>(getResetPasswordUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(resetPasswordRequest),
  });
};

export const getValidateInviteUrl = () => {
  return `/auth/validate_invite`;
};

export const validateInvite = async (
  validateInviteRequest: ValidateInviteRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ValidateInviteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<ValidateInviteResponse>(getValidateInviteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(validateInviteRequest),
  });
};

export const getValidateResetTokenUrl = () => {
  return `/auth/validate_reset_token`;
};

/**
 * @summary Validates a password reset token without consuming it (read-only operation).
Returns HTTP 200 for all cases to prevent user enumeration.
 */
export const validateResetToken = async (
  validateResetTokenRequest: ValidateResetTokenRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ValidateResetTokenResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<ValidateResetTokenResponse>(getValidateResetTokenUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(validateResetTokenRequest),
  });
};

export const getVerifyEmailUrl = () => {
  return `/auth/verify_email`;
};

/**
 * @summary Confirms a pending email token, promotes the email to verified, and clears the pending claim.
 */
export const verifyEmail = async (
  verifyEmailRequest: VerifyEmailRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<VerifyEmailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<VerifyEmailResponse>(getVerifyEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(verifyEmailRequest),
  });
};

export const getGetRecentDocsByUserUrl = (userid: string, maxresults: number) => {
  return `/doc/creator/${encodeURIComponent(String(userid))}/${encodeURIComponent(String(maxresults))}`;
};

/**
 * Doc and thread loading API endpoints
 *
 * Return a list of the most recent docs authored by the user.
 * Returns in reverse chronological order.
 *
 * TODO(2): figure out how to make maxresults optional in extractor?
 */
export const getRecentDocsByUser = async (
  userid: string,
  maxresults: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayDoc[]> => {
  return orvalFetch<DisplayDoc[]>(getGetRecentDocsByUserUrl(userid, maxresults), {
    ...options,
    method: 'GET',
  });
};

export const getGetGuidesByTopicUrl = (topic: string) => {
  return `/doc/guide/${encodeURIComponent(String(topic))}`;
};

/**
 * Get the guides for a topic.
 *
 * Return a JSON map of aspect -> `DisplayDoc`
 *
 * PERF: since removing doc content from the `DocIndex`, this fn now
 * has to do too many await's for different asynchronous doc content
 * lookups from the DB.  We can probably redesign this to make fewer
 * async calls.
 */
export const getGuidesByTopic = async (
  topic: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<GetGuidesByTopic200> => {
  return orvalFetch<GetGuidesByTopic200>(getGetGuidesByTopicUrl(topic), {
    ...options,
    method: 'GET',
  });
};

export const getHideDocUrl = (docid: PublicDocId) => {
  return `/doc/hide/${encodeURIComponent(String(docid))}`;
};

/**
 * The store authorizes and persists the hide, preserving `PostgreSQL`'s timestamp from
 * the first successful request. On success, the handler exclusively gates public-feed
 * publication while it evicts cached full content, clears feed snapshots, and updates
 * graph-held metadata. This ordered reconciliation of persisted and process-local state
 * is the hide operation's read-side convergence; the handler returns `204` only after
 * it completes.
 * @summary Hides one document when the authenticated session user matches its persisted creator.
 */
export const hideDoc = async (
  docid: PublicDocId,
  options?: Parameters<typeof orvalNoContent>[1]
): Promise<void> => {
  return orvalNoContent<void>(getHideDocUrl(docid), {
    ...options,
    method: 'POST',
  });
};

export const getCreateDocUrl = () => {
  return `/doc/new`;
};

export const createDoc = async (
  newDocRequest: NewDocRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<NewDocResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<NewDocResponse>(getCreateDocUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(newDocRequest),
  });
};

export const getSearchDocsUrl = (params: SearchDocsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/doc/search?${stringifiedParams}` : `/doc/search`;
};

/**
 * @summary Returns conversations ranked by their best authorized human post or reply match.
 */
export const searchDocs = async (
  params: SearchDocsParams,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ThreadSearchResult[]> => {
  return orvalFetch<ThreadSearchResult[]>(getSearchDocsUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetDocsInThreadUrl = (docid: PublicDocId) => {
  return `/doc/thread/${encodeURIComponent(String(docid))}`;
};

export const getDocsInThread = async (
  docid: PublicDocId,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ThreadResponse> => {
  return orvalFetch<ThreadResponse>(getGetDocsInThreadUrl(docid), {
    ...options,
    method: 'GET',
  });
};

export const getGetThreadTableOfContentsUrl = (docid: PublicDocId) => {
  return `/doc/thread/${encodeURIComponent(String(docid))}/toc`;
};

/**
 * NOTE: This duplicates the thread construction from `get_docs_in_thread`.
 * In the future, we could find a way to share this computation.
 * @summary Get table of contents for a thread
 */
export const getThreadTableOfContents = async (
  docid: PublicDocId,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ThreadTableOfContents> => {
  return orvalFetch<ThreadTableOfContents>(getGetThreadTableOfContentsUrl(docid), {
    ...options,
    method: 'GET',
  });
};

export const getGetRecentDocsByTopicUrl = (topic: string, maxresults: number) => {
  return `/doc/topic/${encodeURIComponent(String(topic))}/${encodeURIComponent(String(maxresults))}`;
};

/**
 * @summary Returns in reverse chronological order.
 */
export const getRecentDocsByTopic = async (
  topic: string,
  maxresults: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayDoc[]> => {
  return orvalFetch<DisplayDoc[]>(getGetRecentDocsByTopicUrl(topic, maxresults), {
    ...options,
    method: 'GET',
  });
};

export const getTriggerReplyUrl = (docid: PublicDocId) => {
  return `/doc/trigger_reply/${encodeURIComponent(String(docid))}`;
};

export const triggerReply = async (
  docid: PublicDocId,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<TriggerReplyResponse> => {
  return orvalFetch<TriggerReplyResponse>(getTriggerReplyUrl(docid), {
    ...options,
    method: 'POST',
  });
};

export const getCastVoteUrl = () => {
  return `/doc/vote`;
};

/**
 * - `vote_action: "upvote"` or `"downvote"` → upsert vote
 * - `vote_action: "remove"` → remove existing vote
 *
 * Returns `CastVoteResponse` with status and updated vote info on success.
 * @summary Cast or remove a vote on a document.
 */
export const castVote = async (
  castVoteRequest: CastVoteRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<CastVoteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<CastVoteResponse>(getCastVoteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(castVoteRequest),
  });
};

export const getGetDefaultFeedUrl = (n: number) => {
  return `/feed/default/${encodeURIComponent(String(n))}`;
};

export const getDefaultFeed = async (
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetDefaultFeedUrl(n), {
    ...options,
    method: 'GET',
  });
};

export const getGetSuggestedFollowsUrl = () => {
  return `/feed/follows`;
};

export const getSuggestedFollows = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser[]> => {
  return orvalFetch<DisplayUser[]>(getGetSuggestedFollowsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetMentionsFeedUrl = (user: string, n: number) => {
  return `/feed/mentions/${encodeURIComponent(String(user))}/${encodeURIComponent(String(n))}`;
};

export const getMentionsFeed = async (
  user: string,
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetMentionsFeedUrl(user, n), {
    ...options,
    method: 'GET',
  });
};

export const getGetPersonalFeedUrl = (n: number) => {
  return `/feed/personal/${encodeURIComponent(String(n))}`;
};

/**
 * @summary Returns threads whose thread start belongs to the authenticated viewer.
 */
export const getPersonalFeed = async (
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetPersonalFeedUrl(n), {
    ...options,
    method: 'GET',
  });
};

export const getGetPublicFeedUrl = (n: number) => {
  return `/feed/public/${encodeURIComponent(String(n))}`;
};

/**
 * @summary HTTP handler for the unauthenticated homepage feed; a thin wrapper exposing the cached helper
through Axum while preserving shared cache semantics.
 */
export const getPublicFeed = async (
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetPublicFeedUrl(n), {
    ...options,
    method: 'GET',
  });
};

export const getGetSocialFeedUrl = (n: number) => {
  return `/feed/social/${encodeURIComponent(String(n))}`;
};

/**
 * @summary Returns non-owned threads with a followed user's thread start or an explicit human mention.
 */
export const getSocialFeed = async (
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetSocialFeedUrl(n), {
    ...options,
    method: 'GET',
  });
};

export const getGetTopicFeedUrl = (topic: string) => {
  return `/feed/topic/${encodeURIComponent(String(topic))}`;
};

export const getTopicFeed = async (
  topic: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetTopicFeedUrl(topic), {
    ...options,
    method: 'GET',
  });
};

export const getGetUnifiedFeedUrl = (n: number) => {
  return `/feed/unified/${encodeURIComponent(String(n))}`;
};

/**
 * @summary Master feed.
 */
export const getUnifiedFeed = async (
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetUnifiedFeedUrl(n), {
    ...options,
    method: 'GET',
  });
};

export const getGetUserFeedUrl = (user: string, n: number) => {
  return `/feed/user/${encodeURIComponent(String(user))}/${encodeURIComponent(String(n))}`;
};

export const getUserFeed = async (
  user: string,
  n: number,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<FeedItem[]> => {
  return orvalFetch<FeedItem[]>(getGetUserFeedUrl(user, n), {
    ...options,
    method: 'GET',
  });
};

export const getSubmitFeedbackUrl = () => {
  return `/feedback/submit`;
};

/**
 * Tags are recorded verbatim: the handler does not validate or constrain tag
 * values (see `SubmitFeedbackRequest` for the tag policy).
 * The issue is created before its diagnostic file is uploaded and attached;
 * those attachment steps are best effort once the issue exists.
 * @summary Accepts authenticated feedback submissions and files them as Linear issues.
 */
export const submitFeedback = async (
  submitFeedbackRequest: SubmitFeedbackRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<SubmitFeedbackResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<SubmitFeedbackResponse>(getSubmitFeedbackUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(submitFeedbackRequest),
  });
};

export const getGetHealthUrl = () => {
  return `/health`;
};

/**
 * @summary Health check endpoint that returns status, version, and monitoring info
 */
export const getHealth = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<HealthCheckResponse> => {
  return orvalFetch<HealthCheckResponse>(getGetHealthUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetIntegrationsHealthUrl = () => {
  return `/health/integrations`;
};

export const getIntegrationsHealth = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<IntegrationHealthReport> => {
  return orvalFetch<IntegrationHealthReport>(getGetIntegrationsHealthUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getCompleteOauthUrl = () => {
  return `/oauth/callback`;
};

/**
 * @summary OAuth callback handler - processes OAuth code from the frontend
 */
export const completeOauth = async (
  callbackRequest: CallbackRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<CallbackResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<CallbackResponse>(getCompleteOauthUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(callbackRequest),
  });
};

export const getPrepareOauthUrl = (params: PrepareOauthParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/oauth/prepare?${stringifiedParams}` : `/oauth/prepare`;
};

/**
 * @summary Prepares an OAuth flow by generating an authorization URL for the frontend
 */
export const prepareOauth = async (
  params: PrepareOauthParams,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<OAuthUrlResponse> => {
  return orvalFetch<OAuthUrlResponse>(getPrepareOauthUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetOfferDetailsUrl = (cref: ConceptRef) => {
  return `/offer/${encodeURIComponent(String(cref))}`;
};

export const getOfferDetails = async (
  cref: ConceptRef,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayOffer> => {
  return orvalFetch<DisplayOffer>(getGetOfferDetailsUrl(cref), {
    ...options,
    method: 'GET',
  });
};

export const getGetOffersByTopicUrl = (topic: string) => {
  return `/offers/${encodeURIComponent(String(topic))}`;
};

export const getOffersByTopic = async (
  topic: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayOffer[]> => {
  return orvalFetch<DisplayOffer[]>(getGetOffersByTopicUrl(topic), {
    ...options,
    method: 'GET',
  });
};

export const getGetReconInfoByRefUrl = (refs: string) => {
  return `/recon/${encodeURIComponent(String(refs))}`;
};

export const getReconInfoByRef = async (
  refs: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ReconInfoResponse> => {
  return orvalFetch<ReconInfoResponse>(getGetReconInfoByRefUrl(refs), {
    ...options,
    method: 'GET',
  });
};

export const getGetPublicReviewUrl = (reviewId: PublicDocId) => {
  return `/review/${encodeURIComponent(String(reviewId))}`;
};

/**
 * @summary Returns one minimized review document after purpose-specific public classification.
 */
export const getPublicReview = async (
  reviewId: PublicDocId,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<PublicReviewProjection> => {
  return orvalFetch<PublicReviewProjection>(getGetPublicReviewUrl(reviewId), {
    ...options,
    method: 'GET',
  });
};

export const getSearchConceptsByPrefixUrl = (q: string) => {
  return `/schema/prefix_search/${encodeURIComponent(String(q))}`;
};

export const searchConceptsByPrefix = async (
  q: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayConceptRef[]> => {
  return orvalFetch<DisplayConceptRef[]>(getSearchConceptsByPrefixUrl(q), {
    ...options,
    method: 'GET',
  });
};

export const getGetSchemaByRefUrl = (refs: string) => {
  return `/schema/${encodeURIComponent(String(refs))}`;
};

/**
 * @summary Look up the provided ref and return the fields used by the frontend.
 */
export const getSchemaByRef = async (
  refs: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<SchemaConceptResponse> => {
  return orvalFetch<SchemaConceptResponse>(getGetSchemaByRefUrl(refs), {
    ...options,
    method: 'GET',
  });
};

export const getPreviewAvatarUrl = () => {
  return `/user/avatar-preview`;
};

/**
 * @summary Generates an avatar preview response for the provided avatar request payload.
 */
export const previewAvatar = async (
  avatarPreviewRequest: AvatarPreviewRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<Blob | PreviewAvatar200Two> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<Blob | PreviewAvatar200Two>(getPreviewAvatarUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(avatarPreviewRequest),
  });
};

export const getGetAvatarSettingsUrl = () => {
  return `/user/avatar-settings`;
};

/**
 * @summary Returns the authenticated user's editable avatar settings and suggestions.
 */
export const getAvatarSettings = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<AvatarSettingsResponse> => {
  return orvalFetch<AvatarSettingsResponse>(getGetAvatarSettingsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getPatchAvatarSettingsUrl = () => {
  return `/user/avatar-settings`;
};

/**
 * @summary Updates the authenticated user's avatar selection and source configuration.
 */
export const patchAvatarSettings = async (
  patchAvatarSettingsRequest: PatchAvatarSettingsRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<AvatarSettingsPatchOutcome> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<AvatarSettingsPatchOutcome>(getPatchAvatarSettingsUrl(), {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchAvatarSettingsRequest),
  });
};

export type getEffectiveAvatarResponse200 = {
  data: Blob;
  status: 200;
};

export type getEffectiveAvatarResponse304 = {
  data: void;
  status: 304;
};

export type getEffectiveAvatarResponseDefault = {
  data: ApiErrorEnvelope;
  status: Exclude<HTTPStatusCodes, 200 | 304>;
};

export type getEffectiveAvatarResponseSuccess = getEffectiveAvatarResponse200 & {
  headers: Headers;
};
export type getEffectiveAvatarResponseError = (
  getEffectiveAvatarResponse304 | getEffectiveAvatarResponseDefault
) & {
  headers: Headers;
};

export type getEffectiveAvatarResponse =
  getEffectiveAvatarResponseSuccess | getEffectiveAvatarResponseError;

export const getGetEffectiveAvatarUrl = (username: string) => {
  return `/user/avatar/${encodeURIComponent(String(username))}`;
};

/**
 * @summary Returns the effective public avatar SVG for a user, honoring HTTP cache headers.
 */
export const getEffectiveAvatar = async (
  username: string,
  options?: Parameters<typeof orvalResponse>[1]
): Promise<getEffectiveAvatarResponse> => {
  return orvalResponse<getEffectiveAvatarResponse>(getGetEffectiveAvatarUrl(username), {
    ...options,
    method: 'GET',
  });
};

export const getGetCollectionsUrl = () => {
  return `/user/collections`;
};

export const getCollections = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<CollectionsPayload> => {
  return orvalFetch<CollectionsPayload>(getGetCollectionsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getAddOfferToCollectionByUrlUrl = () => {
  return `/user/collections/add_offer_by_url`;
};

export const addOfferToCollectionByUrl = async (
  addOfferByUrlRequest: AddOfferByUrlRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<SuccessResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<SuccessResponse>(getAddOfferToCollectionByUrlUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(addOfferByUrlRequest),
  });
};

export const getDeleteAccountUrl = () => {
  return `/user/delete_account`;
};

/**
 * @summary Handler to process an account deletion request
 */
export const deleteAccount = async (
  deleteAccountRequest: DeleteAccountRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DeleteAccountResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DeleteAccountResponse>(getDeleteAccountUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteAccountRequest),
  });
};

export const getGetUserDetailsUrl = (id: string) => {
  return `/user/get_details/${encodeURIComponent(String(id))}`;
};

export const getUserDetails = async (
  id: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  return orvalFetch<DisplayUser>(getGetUserDetailsUrl(id), {
    ...options,
    method: 'GET',
  });
};

export const getGetCurrentUserUrl = () => {
  return `/user/info`;
};

export const getCurrentUser = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  return orvalFetch<DisplayUser>(getGetCurrentUserUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetInviteDashboardUrl = () => {
  return `/user/invites`;
};

export const getInviteDashboard = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<InviteDashboardResponse> => {
  return orvalFetch<InviteDashboardResponse>(getGetInviteDashboardUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getCreateInviteUrl = () => {
  return `/user/invites`;
};

export const createInvite = async (
  createInviteRequest: CreateInviteRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<CreateInviteResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<CreateInviteResponse>(getCreateInviteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createInviteRequest),
  });
};

export const getCancelInviteUrl = () => {
  return `/user/invites/cancel`;
};

export const cancelInvite = async (
  cancelInviteRequest: CancelInviteRequest,
  options?: Parameters<typeof orvalNoContent>[1]
): Promise<void> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalNoContent<void>(getCancelInviteUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cancelInviteRequest),
  });
};

export const getRequestInviteCreditsUrl = () => {
  return `/user/invites/request_more`;
};

export const requestInviteCredits = async (
  options?: Parameters<typeof orvalNoContent>[1]
): Promise<void> => {
  return orvalNoContent<void>(getRequestInviteCreditsUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getGetUsersUrl = (params?: GetUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/list?${stringifiedParams}` : `/user/list`;
};

/**
 * @summary List all users with optional limit and offset
 */
export const getUsers = async (
  params?: GetUsersParams,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser[]> => {
  return orvalFetch<DisplayUser[]>(getGetUsersUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getGetUserProfileUrl = (username: string) => {
  return `/user/profile/${encodeURIComponent(String(username))}`;
};

export const getUserProfile = async (
  username: string,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<PublicUserProfile> => {
  return orvalFetch<PublicUserProfile>(getGetUserProfileUrl(username), {
    ...options,
    method: 'GET',
  });
};

export const getRemoveOauthIdentityUrl = () => {
  return `/user/remove_oauth_identity`;
};

/**
 * @summary Handler to remove an OAuth identity from the user's account
 */
export const removeOauthIdentity = async (
  removeOAuthIdentityRequest: RemoveOAuthIdentityRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DisplayUser>(getRemoveOauthIdentityUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(removeOAuthIdentityRequest),
  });
};

export const getResendEmailVerificationUrl = () => {
  return `/user/resend_email_verification`;
};

/**
 * @summary Reissues a verification email by replacing the user's pending token and expiry.
 */
export const resendEmailVerification = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<ResendEmailVerificationResponse> => {
  return orvalFetch<ResendEmailVerificationResponse>(getResendEmailVerificationUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getSearchUsersUrl = (params: SearchUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/user/search?${stringifiedParams}` : `/user/search`;
};

export const searchUsers = async (
  params: SearchUsersParams,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<UserSearchResult[]> => {
  return orvalFetch<UserSearchResult[]>(getSearchUsersUrl(params), {
    ...options,
    method: 'GET',
  });
};

export const getSearchUsersByInterestsUrl = () => {
  return `/user/search_by_interests`;
};

export const searchUsersByInterests = async (
  interestSearchRequest: InterestSearchRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<UserSearchResult[]> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<UserSearchResult[]>(getSearchUsersByInterestsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(interestSearchRequest),
  });
};

export const getGetMutualUsersUrl = () => {
  return `/user/search_mutual`;
};

export const getMutualUsers = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<UserSearchResult[]> => {
  return orvalFetch<UserSearchResult[]>(getGetMutualUsersUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getUpdateDiscoverabilityUrl = () => {
  return `/user/set_discoverability`;
};

export const updateDiscoverability = async (
  updateDiscoverabilityRequest: UpdateDiscoverabilityRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DisplayUser>(getUpdateDiscoverabilityUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateDiscoverabilityRequest),
  });
};

export const getUpdateEmailUrl = () => {
  return `/user/set_email`;
};

/**
 * @summary Update the email address for the currently authenticated user
 */
export const updateEmail = async (
  updateEmailRequest: UpdateEmailRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<UpdateEmailResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<UpdateEmailResponse>(getUpdateEmailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateEmailRequest),
  });
};

export const getUpdateMarketplacePreferenceUrl = () => {
  return `/user/set_marketplace_preference`;
};

export const updateMarketplacePreference = async (
  updateMarketplacePreferenceRequest: UpdateMarketplacePreferenceRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DisplayUser>(getUpdateMarketplacePreferenceUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateMarketplacePreferenceRequest),
  });
};

export const getUpdatePasswordUrl = () => {
  return `/user/set_password`;
};

export const updatePassword = async (
  updatePasswordRequest: UpdatePasswordRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<SuccessResponse> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<SuccessResponse>(getUpdatePasswordUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePasswordRequest),
  });
};

export const getSetUserWelcomedUrl = () => {
  return `/user/set_welcomed`;
};

/**
 * @summary Persists the authenticated user's home welcome-card visibility preference.
Both Account resets and home-page dismissals use this operation.
 */
export const setUserWelcomed = async (
  setUserWelcomedRequest: SetUserWelcomedRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DisplayUser>(getSetUserWelcomedUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setUserWelcomedRequest),
  });
};

export const getStopEmailVerificationUrl = () => {
  return `/user/stop_email_verification`;
};

/**
 * @summary Removes the user's pending email verification without changing the verified email.
 */
export const stopEmailVerification = async (
  options?: Parameters<typeof orvalFetch>[1]
): Promise<StopEmailVerificationResponse> => {
  return orvalFetch<StopEmailVerificationResponse>(getStopEmailVerificationUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getUpdateCollectionsUrl = () => {
  return `/user/update_collections`;
};

export const updateCollections = async (
  updateCollectionRequest: UpdateCollectionRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DisplayUser>(getUpdateCollectionsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateCollectionRequest),
  });
};

export const getUpdateFollowsUrl = () => {
  return `/user/update_follows`;
};

/**
 * @summary Unified handler for updating both topic follows and user follows.
Updates the follows info for the authenticated user.
 */
export const updateFollows = async (
  updateFollowsRequest: UpdateFollowsRequest,
  options?: Parameters<typeof orvalFetch>[1]
): Promise<DisplayUser> => {
  const getHeaders = (
    h?: NonNullable<RequestInit['headers']>
  ): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return orvalFetch<DisplayUser>(getUpdateFollowsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updateFollowsRequest),
  });
};
